export default "__VITE_ASSET__DclgYP5i__"